export default __webpack_public_path__ + "static/media/no-data-proponent.a78e3859.svg";